<template lang="pug">
  b-modal(
    size="lg",
    v-model="open",
    header-class="lmm-common-popup-header",
    hide-footer)
    template(slot="modal-header")
      img(src="../../assets/admin_main_log.svg" style="height: 20px")
    div.image-wrap
      div.offline-block(v-if="alive != 1")
        div OFFLINE
      l-image(:src="source", :placeholder="`${AppState.Path.image}/live/live_no_img.jpg`", contain)
</template>

<script>
export default {
  name: 'liveview-dialog',
  props: ['show', 'source', 'alive'],
  computed: {
    open: {
      get () {
        return this.show
      },
      set (n) {
        this.$emit('change', n)
      }
    }
  },
  methods: {
    loaded () {
      this.isBroken = false
    },
    fallback () {
      this.isBroken = true
    }
  },
  data () {
    return {
      isBroken: true
    }
  }
}
</script>

<style lang="scss" scoped src="./dialogs.scss"></style>
